/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://yf6lvd4vtvawlkth5qbnmirehe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "kartivappRESTAPI",
            "endpoint": "https://kcbr3tis3m.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:18cc456c-dd01-41ee-832a-aef72d9a338a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_JEFcBlGI0",
    "aws_user_pools_web_client_id": "3qoso9vquqose667b4s0os15i8",
    "oauth": {
        "domain": "kartivapp.auth.us-east-1.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/,https://app.kartiv.com/,https://kartiv-app-git-staging-kartiv-s-team.vercel.app/",
        "redirectSignOut": "http://localhost:3000/,https://app.kartiv.com/,https://kartiv-app-git-staging-kartiv-s-team.vercel.app/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "GIVEN_NAME",
        "FAMILY_NAME",
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 10,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "kartivappusersdata162712-production",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
